import React from 'react';
import startCase from 'lodash/startCase';

import ReviewButton from '../ReviewButton';
import styles from './PendingTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function PendingTableRow({ submission }) {
  const {
    date,
    github_link: githubLink,
    thesis_file_link: thesisFileLink,
    project_zip_link: projectZipLink,
    program,
    user,
  } = submission;
  const { name, phone_number: phoneNumber, email } = user || {};

  return (
    <TableRow className={styles.root}>
      <TableCell className={styles.rowCell}>{name}</TableCell>
      <TableCell className={styles.rowCell}>{phoneNumber}</TableCell>
      <TableCell className={styles.rowCell}>{date}</TableCell>
      <TableCell className={styles.rowLongCell}>{startCase(program)}</TableCell>
      <TableCell className={styles.noteCell}>{email}</TableCell>
      <TableCell className={styles.noteCell}>
        {githubLink ? (
          <a
            href={githubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="ellipsis link"
          >
            {githubLink}
          </a>
        ) : (
          'N/A'
        )}
      </TableCell>
      <TableCell className={styles.downloadLinks}>
        {thesisFileLink ? (
          <a
            className="ellipsis link"
            href={thesisFileLink}
            rel="noopener noreferrer"
            target="_blank"
          >
            {thesisFileLink}
          </a>
        ) : (
          'N/A'
        )}
      </TableCell>
      <TableCell className={styles.downloadLinks}>
        {projectZipLink ? (
          <a
            className="ellipsis link"
            href={projectZipLink}
            rel="noopener noreferrer"
            download
          >
            {projectZipLink}
          </a>
        ) : (
          'N/A'
        )}
      </TableCell>
      <TableCell className={styles.actionCell}>
        <ReviewButton submission={submission} />
      </TableCell>
    </TableRow>
  );
}

export default PendingTableRow;
